export default {
  app: {
    connectionIssues: '[FE] Возможные проблемы с интернетом!',
    loginAgainRequired: '[FE] Нужно перезайти на сайт',
    unknownError: '[FE] Неизвестная ошибка',
    appErrors: '[FE] Проблемы с сайтом',
  },
};
